import { RSAA } from 'redux-api-middleware';
import { selectors } from 'app-webtech-core/selectors';
import { FETCH_SERIES_SEASONS } from './types';

export const vodContentFetchSeriesSeasonAPIRequest = (seriesId, baseUrl) => ({
  [RSAA]: {
    endpoint: `${baseUrl}/v3/vod/series/${seriesId}/seasons`,
    method: 'GET',
    credentials: 'same-origin',
    types: [
      {
        type: FETCH_SERIES_SEASONS.REQUEST,
        meta: {
          seriesId,
        },
      },
      {
        type: FETCH_SERIES_SEASONS.SUCCESS,
        payload: (action, state, res) => res.json(),
        meta: {
          seriesId,
        },
      },
      {
        type: FETCH_SERIES_SEASONS.FAILURE,
        meta: {
          seriesId,
        },
      },
    ],
  },
});

export const vodContentFetchSeriesSeasonAction = (serieId) => async (dispatch, getState) => {
  const state = getState();
  const vodUrl = selectors.application.servers(state).vod;
  return dispatch(vodContentFetchSeriesSeasonAPIRequest(serieId, vodUrl));
};
